var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useAppSelector } from '../../store';
import { activeSpeakersSelector } from '../../store/slices/activeSpeakersSlice';
import { participantsSelector } from '../../store/slices/participantSlice';
import SpeakerComponent from './speaker';
const ActiveSpeakers = () => {
    _react_refresh_temp_2();
    const activeSpeakers = useAppSelector(activeSpeakersSelector.selectAll);
    const participantIds = useAppSelector(participantsSelector.selectIds);
    const activeSpeakersElms = useMemo(() => {
        if (!activeSpeakers.length) {
            return null;
        }
        return activeSpeakers.map((speaker) => {
            if (participantIds.find((p) => p === String(speaker.userId))) {
                return _jsx(SpeakerComponent, { speaker: speaker }, speaker.userId);
            }
        });
    }, [activeSpeakers, participantIds]);
    return activeSpeakersElms ? (_jsx("div", { className: "active-speakers-wrap flex w-full items-center justify-center absolute top-0 ltr:right-8 rtl:left-8 z-[9999]", children: activeSpeakersElms })) : null;
};
_react_refresh_temp_1 = ActiveSpeakers;
$RefreshReg$(_react_refresh_temp_1, "ActiveSpeakers");
_react_refresh_temp_2(ActiveSpeakers, "7HtmD0DOELx/jBryXRVD4uHoQDk=", false, () => [useAppSelector, useAppSelector]);
export default ActiveSpeakers;
